module.exports = __webpack_public_path__ + "static/media/seasonalski.bf9b5e3a.webp";